import './CurrentRequest.scss'
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import AcDialog from '../AcDialog/AcDialog';
import AppSelect from '../AppSelect/AppSelect';
import SdoRequestStatus from '../SdoRequestStatus/SdoRequestStatus';
import { getDateAndTimeFormat } from '../../helpers/dateHelpers';
import { formatDatesRequested, formatDatesRequestedOn } from '../../pages/SdoAdmin/sdoAdminHelper';
import { useSdoAdminEligibilityCriteriaProvider } from '../../providers/SdoAdminEligibilityCriteriaProvider';

export default function CurrentRequest({requestNo, currentRequest, pilotId}) {
    const sdoAdminEligibilityCriteriaContext = useSdoAdminEligibilityCriteriaProvider();
    const { t } = useTranslation();
    const [showRevokeDialog, setShowRevokeDialog] = useState(false); 
    
    const formattedRequest = {
        year: currentRequest.year,
        dates: formatDatesRequested(new Date(currentRequest.startDate), new Date(currentRequest.endDate), currentRequest.days),
        requestedOn: formatDatesRequestedOn(currentRequest.requestedOn),
        status: currentRequest.status,
        remarks: currentRequest.remarks
    }

    const selects = useRef([]);

    const handleClose = () => {
        setShowRevokeDialog(false);
    }

    const handleRevokeClick = () => {
        const createdOn = getDateAndTimeFormat();
        const startDateMonth = Number(currentRequest.month);
        const reason = selects.current['Reason to Revoke'].querySelector('input').value;
        sdoAdminEligibilityCriteriaContext.revokeRequest(pilotId, startDateMonth, currentRequest.year, reason, createdOn, currentRequest.transactionId);
    }

    const popup = () => {
        return {
            icon: 'icon-circle-flight',
            title: t('specialDayOff.adminEligibilityCriteria.revokePopupTitle'),
            description: `${t('specialDayOff.adminEligibilityCriteria.revokePopupDescription')} <br> ${t('specialDayOff.adminEligibilityCriteria.revokePopupDescription1')} <b> ${t('specialDayOff.adminEligibilityCriteria.revokePopupDescription2')}`,
            actionLabel: t('specialDayOff.adminEligibilityCriteria.setLimits.popup.cancel'),
            handleAction: handleClose,
            secondaryActionLabel: t('specialDayOff.adminEligibilityCriteria.revokeSdo'),
            handleSecondaryAction: handleRevokeClick
        }
    }

    return (
        <div className='c-current-request'>
            <span className='current-request__title'>
                {t('specialDayOff.adminEligibilityCriteria.currentRequestTitle')} {requestNo}
            </span>
            <div className='c-current-request-container'>
                <div className='c-current-request__columns'>
                    <p className='columns__year'>{t('specialDayOff.adminEligibilityCriteria.year')}</p>
                    <p className='columns__dates'>{t('specialDayOff.adminEligibilityCriteria.dates')}</p>
                    <p className='columns__req-on'>{t('specialDayOff.adminEligibilityCriteria.requestedOn')}</p>
                    <p className='columns__status'>{t('specialDayOff.adminEligibilityCriteria.status')}</p>
                </div>
                <div className='c-current-request__details'>
                    <p className='details__year'>{formattedRequest.year}</p>
                    <p className='details__dates'>{formattedRequest.dates}</p>
                    <p className='details__req-on'>{formattedRequest.requestedOn}</p>
                    <div className='details__status'>
                        <SdoRequestStatus 
                            status={formattedRequest.status} 
                            remarks={formattedRequest.remarks}
                        />
                    </div>
                </div>
                <div className='c-current-request-footer'>
                    <div className="c-select--revoke">
                        <AppSelect 
                            fillElements={["Training", "Seniority", "Vacation", "Other"]}
                            multiSelect={false} 
                            selectedItem={"Training"} 
                            selectLabel="Reason to Revoke" 
                            selectRef={selects} 
                        />
                    </div>
                    <AcDialog open={showRevokeDialog} onClose={handleClose} data={popup()} />
                    <Button 
                        variant="outlined" 
                        className='btn-exception' 
                        onClick={() => setShowRevokeDialog(true)}
                    >
                        {t('specialDayOff.adminEligibilityCriteria.revokeBtn')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
